// Libs
import React from 'react';
import { withRouter } from 'react-router-dom';
import { Container } from 'react-bootstrap';

// Services & Helpers
import GlobalStateService from 'services/GlobalStateService';
import HelpService from 'services/HelpService';
import TextHelpers from 'helpers/TextHelpers';

// Components
import Loader from 'components/common/Loader';
import PageHeader from 'components/common/PageHeader';
import { Link } from 'react-router-dom/cjs/react-router-dom';

//-------------------------------------------------------------------------------------------------------------------

class HelpPage extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isLoading: true
        };
    }
    
    componentDidMount() {
        window.scrollTo(0, 0);
        GlobalStateService.setValues({ area: 'help' });
        this.loadList();
        this.loadArticle();
    }

    componentDidUpdate(oldProps) {
        if (this.props.match.params.slug != oldProps.match.params.slug) {
            this.loadArticle();
        }
    }

    async loadList() {
        const helpArticles = await HelpService.listArticles();
        helpArticles.forEach(ha => {
            ha.searchString = TextHelpers.simplifySearchString(ha.title);
        });
        this.setState({
            helpArticles,
            helpArticlesFiltered: helpArticles,
            isLoading: false
        });
    }
    
    async loadArticle() {
        const { slug } = this.props.match.params;
        this.setState({ isLoadingArticle: true });
        let helpArticle = null;
        if (slug) {
            helpArticle = await HelpService.getArticleBySlug(slug);
        }
        this.setState({
            helpArticle,
            isLoadingArticle: false
        }, () => {
            this.scrollToArticle();
        });
    }

    search(query) {
        const helpArticlesFiltered = this.getArticlesFiltered(query);
        this.setState({
            helpArticlesFiltered,
            query
        });
    }

    getArticlesFiltered(query) {
        query = TextHelpers.simplifySearchString(query);
        const queryParts = query.split(' ');
        const helpArticles = this.state.helpArticles.filter(ha => queryParts.every(qp => ha.searchString.indexOf(qp) != -1));
        return helpArticles;
    }

    scrollToArticle() {
        if (window.innerWidth < 768) {
            const element = document.querySelector('section.help-article');
            element.scrollIntoView();
        }
    }

    render() {
        return (
            <div className="page help-page">

                <PageHeader>
                    <h1>Help</h1>
                </PageHeader>

                <main>

                    <Container>

                        <section>

                            {this.renderHelpArticleList()}

                        </section>

                        <section className="help-article">

                            {this.renderArticle()}

                        </section>

                    </Container>

                </main>

            </div>
        );
    }

    renderHelpArticleList() {
        const {
            isLoading,
            helpArticlesFiltered
        } = this.state;
        const { slug } = this.props.match.params;

        if (isLoading) {
            return (<Loader />);
        }

        return (<>

            <div className="search">
                <input
                    type="search"
                    autoFocus
                    placeholder={`Search for an article...`}
                    onChange={e => this.search(e.target.value)}
                />
                <span className="icon fa-solid fa-search" />
            </div>

            {helpArticlesFiltered.length > 0 ?
                <ul className="thing-list">
                    {helpArticlesFiltered.map(ha =>
                        <li key={ha.id} className={ha.slug == slug ? 'active' : ''}>
                            <Link to={`/help/${ha.slug}`}>
                                {ha.title}
                            </Link>
                        </li>
                    )}
                </ul> :
                <div className="empty-text">Sorry, no articles found</div>
            }
        </>);
    }

    renderArticle() {
        const { helpArticle, isLoadingArticle } = this.state;

        if (isLoadingArticle) {
            return (<Loader />);
        }
        if (helpArticle) {
            return (<>
                <h2>{helpArticle.title}</h2>
                <div dangerouslySetInnerHTML={{ __html: helpArticle.body }}></div>
            </>);
        }

        return (
            <div className="empty-text">
                Please select a help article from the menu
            </div>
        );
    }
}

export default withRouter(HelpPage);